<div class="card mt-2">
    <div class="card-header d-flex justify-content-between align-items-center bg-transparent border-bottom-0">
        <div class="column" style="width: 100%;">
            <h6 class="m-0 mt-3">Top 10 {{selectedToggle == 'COMPRA' ? 'proveedores' : 'clientes'}}</h6>
            <div class="table-responsive mt-3">
                <table id="example-datatable" class="table table-vcenter table-condensed table-bordered">
                    <thead>
                        <tr>
                            <th class="text-center bg-primary" style="color:#fff; font-size: 13px;">N°</th>
                            <th class="bg-primary" style="color:#fff; font-size: 13px;">Proveedor</th>
                            <th class="bg-primary" style="color:#fff; font-size: 13px;">Monto</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of top10List; let i = index">
                            <td class="text-center">{{i + 1}}</td>
                            <td>{{item?.nombre}}</td>
                            <td>${{(item?.monto) ? (item?.monto | currency:'CLP':'':'1.0-0') : '' }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>        
        </div>
    </div>
</div>